(function($) {
	var CurrentLanguage = {
		get: function() {
			return TL.app.language;
		},
		set: function(lang) {
			TL.app.language = lang;
		}
  }
  
  /**
	 * Register method to global for get language
	 * @since 2019-06-05
	 */
	$.extend(true, window.TL, {
		language: CurrentLanguage
	});
  
  /**
   * Just open language panel
   */
  $(document).on('click', '.js-language-panel', event => {
		event.preventDefault();
		$.magnificPopup.open({
			items: {
				src: event.currentTarget.hash,
				type: 'inline'
			},
			callbacks: {
				open: function() {
					var $el = this.content;
					$el.find(`a[data-lang="${CurrentLanguage.get()}"]`).addClass('current');
					$el.on('click', 'a', function() {
						var lang = this.dataset.lang;
						CurrentLanguage.set(lang);

						$(this).addClass('current').parents('.language-panel').find('li a').not(this).removeClass('current');
						$.magnificPopup.instance.close();
					});
				}
			},
			mainClass: 'component-popup mfp-zoom-up',
			removalDelay: 200,
			alignTop: true
		});
  });
  
  /**
	 * Watching app data for update UI
	 * @since 2019-03-05
	 */
    watch(TL.app, function (prop, action, newValue, oldValue) {

        if (newValue === undefined) {
            
        } else {

            if ('language' === prop) {
                var flag;
                switch (newValue.toLowerCase()) {
                case 'en': flag = 'gb'; break;
                    case 'ja': flag = 'jp'; break;
                    case 'ko': flag = 'kr'; break;
                    case 'vi': flag = 'vn'; break;
                    case 'zh':
                    case 'zh_tw': flag = 'cn'; break;
                    default: flag = newValue.toLowerCase();
                }
                $('.js-language-panel .text').html(`<span class="flag-icon flag-icon-${flag}"></span>`);
            }
        }
    });
  
  /**
   * Set current language
   * @since 2019-03-05
   */
  CurrentLanguage.set('en');
})(jQuery);